import React from 'react';
import { styles } from '../styles';

export default function PageHeader({
  answeredCount,
  headerTitle,
  isMobile,
  pct,
  topWrapStyle,
  total,
}) {
  return (
    <div style={topWrapStyle}>
      <div style={styles.topInner(isMobile)}>
        <img
          src="/images/Logo-Cooperplace-Branca.png"
          alt="CooperPlace"
          style={styles.logo}
          draggable={false}
        />
      </div>

      <div style={styles.headerArea(isMobile)}>
        <div style={styles.headerRow(isMobile)}>
          <div style={{ minWidth: 0 }}>
            <div style={styles.headerTitle}>{headerTitle}</div>
            <div style={styles.headerSub}>Resposta identificada</div>
          </div>

          <div style={styles.counterPill}>
            {answeredCount} de {total} respondidas
          </div>
        </div>

        <div style={styles.progressTrack}>
          <div style={styles.progressFill(pct)} />
        </div>
      </div>
    </div>
  );
}
